import Icon from "./Icon";

export default function Drawer({ open, onClose, title, subtitle, children, footer, wide }) {
  if (!open) return null;
  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className={`drawer ${wide ? "drawer-wide" : ""}`}>
        <div className="drawer-head">
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--ink-900)" }}>{title}</div>
            {subtitle && (
              <div style={{ fontSize: 12, color: "var(--ink-500)", marginTop: 2 }}>{subtitle}</div>
            )}
          </div>
          <button className="icon-btn" onClick={onClose} title="Close">
            <Icon name="x" size={16} />
          </button>
        </div>
        <div className="drawer-body">{children}</div>
        {footer && <div className="drawer-foot">{footer}</div>}
      </div>
    </>
  );
}
